import { render, staticRenderFns } from "./ApproverItemPage.vue?vue&type=template&id=187fe33a&scoped=true&"
import script from "./ApproverItemPage.vue?vue&type=script&lang=js&"
export * from "./ApproverItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ApproverItemPage.vue?vue&type=style&index=0&id=187fe33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187fe33a",
  null
  
)

export default component.exports